
/* KORG ⛰
----------------------------------------------------------------------------------------------------*/

export default class Korg {

    constructor(selector, preventDocScroll) {
        this.isPreventing = false
        this.shouldPreventDocScroll = preventDocScroll

        this.detectPassiveSupport()
        this.getContainer(selector)

        this.ts = (e) => { this.onTouchStart(e) }
        this.m = (e) => { this.onMove(e) }
        this.dm = (e) => { this.onDocMove(e) }
    }




    /* Handlers
    --------------------------------------------------------- */

    onTouchStart(e) {
        if (e.targetTouches.length === 1) {
            this.startTouchY = e.targetTouches[0].clientY
        }
    }


    onMove(e) {
        e.stopPropagation()

        const isTouch = e.type === 'touchmove'

        const { clientHeight, scrollHeight, scrollTop } = this.$scrollArea
        const mY = isTouch ? e.targetTouches[0].clientY - this.startTouchY : e.deltaY

        const isAtStart = scrollTop === 0
        const isAtEnd = (scrollHeight - scrollTop) <= clientHeight

        const isGoingUp = isTouch ? mY > 0 : mY < 0
        const isGoingDown = isTouch ? mY < 0 : mY > 0


        if (((isAtStart && isGoingUp) || (isAtEnd && isGoingDown)) && e.cancelable) {
            e.preventDefault()
        }
    }


    onDocMove(e) {
        if (!this.isPreventing) return
        e.preventDefault()
    }




    /* Actions
    --------------------------------------------------------- */

    toggle(shouldPrevent = !this.isPreventing) {
        if (shouldPrevent === this.isPreventing) return

        this.isPreventing = shouldPrevent

        if (shouldPrevent) {
            if (this.shouldPreventDocScroll) {
                document.addEventListener('touchmove', this.dm, this.aEL)
                document.addEventListener('wheel', this.dm, this.aEL)
            }

            this.$scrollArea.addEventListener('touchstart', this.ts)
            this.$scrollArea.addEventListener('touchmove', this.m, this.aEL)
            this.$scrollArea.addEventListener('wheel', this.m, this.aEL)
        } else {
            if (this.shouldPreventDocScroll) {
                document.removeEventListener('touchmove', this.dm, this.aEL)
                document.removeEventListener('wheel', this.dm, this.aEL)
            }

            this.$scrollArea.removeEventListener('touchstart', this.ts)
            this.$scrollArea.removeEventListener('touchmove', this.m)
            this.$scrollArea.removeEventListener('wheel', this.m)
        }
    }


    // “Piss Off Ghost” — Start Overscroll prevention
    start() {
        this.toggle(true)
    }


    // “He’s freakin’ gone” — Stop Overscroll prevention
    stop() {
        this.toggle(false)
    }




    /* Values
    --------------------------------------------------------- */

    detectPassiveSupport() {
        let supportsPassive = false

        try {
            const opts = Object.defineProperty({}, 'passive', {
                get: () => {
                    supportsPassive = true
                },
            })

            window.addEventListener('test', null, opts)
        } catch (e) {
            //
        }

        this.aEL = supportsPassive ? { passive: false } : false
    }


    getContainer(selector) {
        this.$scrollArea = typeof selector === 'object' ? selector : document.querySelector(selector)
    }

}




/* CONSTANTS AND HELPERS
---------------------------------------------------------------------------------------------------- */



